import React from 'react'
import Grid from '../layout/grid'
import NumberFormat from 'react-number-format';

export default props => (
    <Grid cols={props.cols} style={{ minWidth: props.minWidth, maxWidth: props.maxWidth, paddingBottom: props.paddingBottom, marginBottom: props.marginBottom }}>
        <div className='form-group' style={{ paddingBottom: props.paddingBottom, marginBottom: props.marginBottom }}>
            {props.label &&
            <label htmlFor={props.name}>{props.label}</label>}
            {props.onChange ? (
				<NumberFormat {...props.input} className='form-control'
					readOnly={props.readOnly} type={props.type}
					placeholder={props.placeholder}
					decimalSeparator={","} 
                    decimalScale={props.casas} 
                    fixedDecimalScale={props.casas} 
                    thousandSeparator={props.semSeparadorMilhar ? false : '.'}
					value={props.value}
					onChange={props.onChange}  />
			) : (
                <NumberFormat {...props.input} className='form-control'
                    readOnly={props.readOnly} type={props.type}
                    placeholder={props.placeholder}
                    decimalSeparator={","}
                    decimalScale={props.casas} 
                    fixedDecimalScale={props.casas} 
                    thousandSeparator={props.semSeparadorMilhar ? '' : '.'}  />
            )}
        </div>
    </Grid>
)
